import { AudioInputSelection, AudioSourceInfo, useUserContext } from '../../UserContext'
import AudioInputDeviceSettingsContent from './AudioInputDeviceSettingsContent'
import CrossPlatformDialog from '@/dialogs/components/CrossPlatformDialog'

export default function AudioInputDeviceSettingsDialog({
    mediaSource,
    onClose,
}: {
    mediaSource: AudioSourceInfo
    onClose: () => void
}) {
    const [userState] = useUserContext()

    // gets the AudioInputSelection of this source: AudioSourceInfo if the device
    // is currently selected, null otherwise.
    const mediaSelection: AudioInputSelection | null =
        userState.mediaSelection.audioInputs.find((i) => i.deviceId === mediaSource.deviceId) ?? null
    if (!mediaSelection) {
        return null
    }

    return (
        <CrossPlatformDialog
            frameName={`Dialog:AudioInputDeviceSettingsPage-${mediaSource.audioEngineDeviceId}`}
            classNameBrowser="md:w-[550px]"
            classNameNative="min-w-[520px]"
            browserZIndex={21}
            onDefaultClose={() => onClose()}
        >
            <AudioInputDeviceSettingsContent mediaSelection={mediaSelection} onClose={onClose} />
        </CrossPlatformDialog>
    )
}
